import React, { Fragment } from 'react'
import Link from 'next/link'
import Image from 'next/image'

const BestKnown = ({ speakerData }) => (
  <>
    {speakerData?.map((speaker, i) => (
      <Fragment key={i}>
        {speaker?.popularProjects.length !== 0 && (
          <h1 className="tagline-font text-white tracking-wide text-2xl maxSm:mt-2 maxLg:mt-6">
            BEST KNOWN FOR
          </h1>
        )}
      </Fragment>
    ))}
    <div className="mx-auto bg-black text-white my-5 mb-10">
      <div className="flex flex-row flex-wrap gap-x-6 maxSm:gap-x-2.5">
        {speakerData?.map((speaker, index) => (
          <Fragment key={index}>
            {speaker?.popularProjects?.map((item, i) => (
              <div className=" pb-2 maxSm:pb-[17px]" key={i}>
                {item && item?.assets?.fields?.file?.url ? (
                  <Link href={item && item?.url ? item?.url : ''} legacyBehavior>
                    <a target="_blank">
                      <div className="h-40 w-28 relative mb-4">
                        <Image
                          src={item && 'https:' + item?.assets?.fields?.file?.url}
                          alt="Speaker"
                          layout="fill"
                          objectFit="cover"
                          quality={100}
                          className=" cursor-pointer mb-3 maxSm:mb-2.5 w-full shadow-lg mt-2"
                        />
                      </div>
                      <p className="text-sm max-w-[8em]">{item?.title?.split(':')[0]}</p>
                      <p className="text-xs text-custom-gray-80">{item?.category}</p>
                    </a>
                  </Link>
                ) : (
                  <div></div>
                )}
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  </>
)

export default BestKnown
